<template>
  <div class="size-full flex-col text-gray-700">
    <form
      class="size-full flex-col text-gray-700"
      @submit.prevent="onSubmit"
    >
      <p class="text-sm">Email</p>
      <div class="mb-2 flex w-full flex-col">
        <Field
          v-model.trim="signUpStore.userForm.email"
          class="rounded-md border border-lk-light-gray p-2 text-xs focus:border-lk-green focus:outline-none md:text-sm"
          placeholder="Email"
          type="text"
          name="user[email]"
          label="Email"
          :rules="{ required: true }"
        />
        <ErrorMessage
          name="user[email]"
          class="mt-1 text-sm text-red-500"
        />
      </div>
      <div class="mt-0 flex flex-col items-center">
        <button class="w-full rounded-md bg-lk-green/90 p-2 text-sm text-white hover:bg-lk-green md:text-base">
          Empezar
        </button>
        <a
          class="mt-1 cursor-pointer text-sm hover:underline"
          @click="emit('already-has-account')"
        >
          ¿Ya tienes cuenta? Inicia sesión
        </a>
      </div>
    </form>
  </div>
</template>
<script lang="ts" setup>
import { watch } from 'vue';
import { useForm, Field, ErrorMessage } from 'vee-validate';
import useSignUpStore from 'stores/sign-up-store';
import usersApi from 'api/users';

const emit = defineEmits<{
  'already-has-account': [];
  'switch-to-sign-in': [email: string];
}>();

const signUpStore = useSignUpStore();
const { handleSubmit } = useForm();

const onSubmit = handleSubmit(async () => {
  const response = await usersApi.validateEmail(signUpStore.userForm.email);
  const data = response.data;

  if (!data.valid && !data.error) {
    emit('switch-to-sign-in', signUpStore.userForm.email);
    return;
  }

  signUpStore.currentStep = 'user';
  if (!signUpStore.currentPathIncludesShopsSignUp) window.location.href = '/shops/sign_up';
});

watch(
  () => signUpStore.userForm.email,
  () => {
    signUpStore.userForm.email = signUpStore.userForm.email.toLowerCase();
  },
);
</script>
